import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { signinSeller } from "../../Service/service";

function Login() {
  const [userData, setuserData] = useState({});
  console.log(userData);

  const navigate = useNavigate();

  const onChange = (e) => {
    setuserData({ ...userData, [e.target.name]: e.target.value });
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    console.log(userData);

    if (!userData?.email) {
      toast?.error("Please enter phone");
      return;
    }
    if (!userData?.password) {
      toast?.error("Please enter password");
      return;
    }

    try {
      // signinSeller
      userData.role_name = "User";
      const response = await signinSeller(userData, navigate);
      console.log(response);

      // const response = await fetch("http://localhost:3022/public/userlogin", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json", // Server ko batata hai data JSON format me hai
      //   },
      //   body: JSON.stringify(userData), // Body me data send karte hain
      // });

      // if (response.ok) {
      //   const data = await response.json(); // Response ko JSON me convert kare
      //   // Login successful
      //   // setSuccess("Login successful!");
      //   toast?.success(data.message);
      //   localStorage.setItem("authToken", data.token);
      //   navigate("/profile");
      //   console.log("User data:", data);
      // } else {
      //   const data = await response.json();
      //   console.log("error:", data);
      //   toast?.error(data.message);
      //   // Login failed
      //   // setError(data.message || "Login failed");
      // }
    } catch (err) {
      // setError("Something went wrong. Please try again.");
    }
  };
  return (
    <div>
      <div className="login_treasure">
        <div class="login-container">
          <a href="/">
            <img src="/img/logo.png" style={{ width: "150px" }}></img>
          </a>
          <h2 class="mb-4">
            <b>GATWAY LANDMARK GROUP</b>
          </h2>
          {/* <a href="/walletConnect" class="wallet-connect">
            🔗 Wallet Connect
          </a> */}

          <form>
            <div class="mb-3 text-start">
              <label class="form-label">Email</label>
              <input
                type="text"
                class="form-control"
                placeholder="Please enter email"
                onChange={onChange}
                name="email"
                value={userData?.email}
              />
            </div>
            <div class="mb-3 text-start">
              <label class="form-label">Password</label>
              <input
                type="password"
                class="form-control"
                placeholder="Please enter your password"
                onChange={onChange}
                name="password"
                value={userData?.password}
              />
            </div>
            <div class="d-flex justify-content-between">
              <Link to="/forget-Password" class="bottom-links">
                Forgot Password?
              </Link>
            </div>
            <button type="submit" class="btn btn-login mt-3" onClick={onSubmit}>
              Log in
            </button>
          </form>
          <p class="mt-3">
            Don't have an account?{" "}
            <Link to="/register" class="bottom-links">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
